module.exports = {
    planner: {
        Total: '总共',
        updateHint: '任务状态将在签署后2分钟更新。',
        delete_s: '成功移除意向投资城市',
        delete_err: '移除意向投资城市失败，刷新页面后重试',
        Delete: '移除',

        RealEstateStrategy: '房产投资策略',
        Assets: '资产配置计划',
        SURPLUS: '预算盈余',
        SHORTFALL: '预算差额',

        budgetError: '请输入该城市的预算',
        addTargetCityError: '添加失败',
        addTargetCitySuccess: '添加意向购房城市成功！',
        selectCity: '请选择城市',
        AddTargetCity: '添加意向投资房产',
        SelectInvestmentCity: '请选择有意向投资的城市',
        EstimateCity: '您预期的投资预算是多少？',
        budegtTitle: '我们已为您设置了该城市的购房均价作为预算金额',
        BackToPlanner: '返回云理财',

        Expenses: '支出状况',
        CurrentMonthlyExpenses: '目前每月支出',
        RetirementMonthlyExpenses: '退休后每月支出（预估）',
        RealEstateAllocationTarget: '房产投资配比目标',

        Target: '目标',
        TARGETS: '未来投资筹谋',
        EditTargets: '编辑',
        YourRealEsatet: '您目前的房产价值是',
        BaseTotal: '* 基于您在"房产投资"中输入的房产总价值',
        CurrentlyCalculating: '正在计算中',
        Confirm: '提交',

        RETIREMENTPROPERTYPORTFOLIO: '资产配置明细',
        RealEstateAllocation: '房产配比',
        EXISTINGINVESTMENTS: '当前持有房产',
        AddProperty: '添加房产',
        Name: '房产项目',
        CurrentValue: '当前价值',
        GrossYield: '收益率',
        AnnualCashFlow: '年现金流',
        MortgageFree: '不包括房贷',
        ViewDetails: '查看详情',
        TARGETCITIES: '未来投资筹谋',
        TargetValue: '预期放假',
        CurrentEquilty: '当前资产',
        CurrentCashFlow: '当前现金流',
        TargetAchieved: '目标已达成',
        CashFlow: '现金流(月)',
        RealEstate: '房地产现金流',
        AllOther: '其他投资现金流',

        TOTALS: '全部',
        TotalAssetsAfter10Years: '10年后总资产（预计）',
        CurrentAllocation: '目前总资产',
        ReturnsForecasted: '总回报预测',
        WEALTHALLOCATIONBREAKDOWN: '资产配置明细',
        TENYEARRETURNFORECAST: '预计10年投资回报',
        AdjustReturnForecasts: '预测回报率',
        EditAllocations: '编辑资产配比',
        AssetType: '资产类型',
        AnnGrowth: '预计增长率 %',
        AnnYield: '预计收益率 %',
        TenYrTotalReturns: '10年总回报率 %',
        TenYrTotalReturnsAmount: '10年总回报',

        Growth: '增长率',
        Yield: '收益率',
        Cash: '现金',
        Stocks: '股票',
        Bonds: '债券',
        RealEstate: '房产投资',
        Other: '其他 (黄金, 艺术收藏等)',
        SaveChanges: '保存更改',

        YourWealthAllocation: '您目前的资产配置',
    },

    manage: {
        LearnMore: '了解更多',
        MaximizeRentalIncome: '优化您的租赁收益',
        IncreaseYourReturns: '提高投资收益',
        LowerFinancingCosts: '减少贷款成本',
        OptimizeProperty: '资产配置优化',
        simplifyRentalsMortgages: '智能化管理您的全球房产租赁与贷款。',

        BookaConsultation: '了解最佳方案',
        ViewPropertyDetails: '查看房产详情',
        MyRequiredActions: '当前待办事项',
        todoList: '您目前暂无待办事项',
        CompletedTask: '您的房产更新将在此处显示',
        receiveList: '您的房产更新将在此处显示',
        Milestones: '时间轴',
        COMPLETED: '已完成',
        Purchase: '购房流程',
        Mortgage: '房屋贷款',
        Rental: '房屋租赁',
        MORTGAGE_title: '在此处查看您的贷款事项列表',
        RENT_title: '在此处查看您的租赁事项列表',
        PURCHASE_PROCESS_title: '在此处查看您的购房事项列表',
        MORTGAGE_desc: '目前没有贷款相关事项',
        RENT_desc: '目前没有租赁相关事项',
        PURCHASE_PROCESS_desc: '目前没购房有相关事项',
        ActionRequired: '待办事项',
        ErrorMilestone: '发生错误，请查验处理',
        OverdueMilestone: '逾期事项',
        DueDate: '到期日',
        Task: '事项名称',
        Status: '当前状态',
        Pending: '审核中',
        Future: 'Future',
        OverDue: '逾期',
        Error: '错误',
        Todo: '待办',
        Completed: '已完成',
        Update: '更新',
        Future_update: '未来计划',
        BackManage: '返回管理: ',
        BackEvent: '返回',
        TaskDetails: '事项详情',
        MarkComplete: '立即完成',
        UploadNow: '立即上传',
        SignNow: '立即签订',
        PayNow: '立即支付',
        ConfirmTitle: '是否标记为已完成？',
        Confirm_y: '是的，缺人',
        UploadFiles: '上传文件',
        acceptFile: '仅接受 jpg/png/pdf 类型文件',
        deleteFile_s: '文件已删除',
        UploadFile: '上传',
        uploadPrivacy:
            '*金房本不会在未经您许可的情况下与第三方共享您的个人隐私资料，我们会为您的信息提供安全保护',
        UpdateandComplete: '上传并完成',
    },

    UJ: {
        haevAccount: '已经有帐号了？点击登录',
        currentStep: '第 {currentSection} 步',
        back: '返回',
        welcome: '欢迎',
        commonDesc: '开始制定您的投资计划。',
        question:
            '为了给您提供更合适的投资建议，我们需要了解您的个人情况和需求',
        QTitle1: '完善您的个人信息',
        QDesc1: '让我们进一步了解您的投资需求',
        QTitle2: '选择您感兴趣的城市',
        QDesc2: '根据您的个人情况，提供给您最合适的投资理财建议',
        QTitle3: '设置您感兴趣的城市',
        QDesc3: '在您多元化的投资组合里加入房产投资',
        startBTN: '点击开始',
        totalTimeCostHint: '总用时不超过3分钟',

        first_name: '名字',
        last_name: '姓氏',
        birth: '出生日期',
        gender: '性别',
        cityResidence: '居住城市',
        nationalityName: '国籍',
        currency: '默认货币',
        placeholder: '请输入',

        genderOptions: {
            female: '女',
            male: '男',
        },

        errorMsg: {
            first_name: '请输入您的名字',
            last_name: '请输入您的姓氏',
            birth: '请输入出生日期',
            gender: '请选择性别',
            cityResidence: '请输入您目前居住的城市',
            nationalityName: '请选择您的国家',
            currency: '请选择您常用的货币',
        },

        errorFeedBack: {
            error1: '请填写所有信息',
            error2: '请至少选择一个选项',
            error3: '请至少选择一个地区',
            error4: '请至少选择三个城市',
            error5: '请至少选择三个城市',
            error6: '请至少选择一个选项',
            error7: '请至少选择一个选项',
            error8: '请至少选择一个选项',
            error9: '请至少选择一个选项',
        },

        section1: {
            title: '完善您的个人信息',
            desc: '',
        },

        section2: {
            title: '您购买房屋的主要目的是什么？',
            desc: '请选择您对下一处房产的使用规划',
            buyProperty1: '2-5年内获取投资回报',
            buyProperty2: '退休理财投资',
            buyProperty3: '度假房屋投资',
            buyProperty4: '短期居住使用',
            buyProperty5: '长期居住使用',
        },

        section3: {
            title: '请选择1-3个符合您购房计划的地区',
            desc: '我们把房产使用规划和房产地理位置进行了合理地组合搭配。',
        },

        section4: {
            title: '请选择至少3个您有兴趣购房投资的城市',
            desc:
                '投资多处房产，持有多国货币，多样化的置业投资策略，合理分散投资风险。',
        },

        section5: {
            title: '请预估您在不同城市的购房预算',
            desc:
                '我们已为您设置了该城市的购房均价作为预算金额，若无需更改请直接点击下一步按钮',
            budget: '投资预算',
        },

        section6: {
            title: '退休后，您最理想的生活状态是什么？',
            desc: '您可直接编辑你对未来生活支出的预算',
            option1: '不愁温饱',
            option2: '小康生活',
            option3: '优渥富足',
            subtitle: '预计未来的月度开支',
            perMonth: '月度开支',
        },

        section7: {
            title: '请选择最接近您实际情况的资产配置',
            desc: '注册完成后，您可以再次编辑您的资产配置比例',
            realEstate: '房地产 {num}',
            bonds: '债券 {num}',
            stocks: '股票 {num}',
            cash: '现金 {num}',
            option0: {
                title: '激进型投资',
                desc: '我的资产大部分在股票市场，少部分资产为房地产投资。',
            },
            option1: {
                title: '稳健投资人',
                desc: '我的资产大部分属于在房地产和债券类资产。',
            },
            option2: {
                title: '分散型投资',
                desc: '我的资产平均分布在不同类型的投资产品。',
            },
            option3: {
                title: '新晋投资人',
                desc: '我的资产主要配置在股票类资产和现金。',
            },
        },

        section8: {
            title: '在退休之后，您预计配置多少资金于房地产投资？',
            desc: '您打算在退休前，您计划在房产置业方面投入多少资金？',
            subtitle: '目标房产投资⾦金金额',
            adjustSlider: '调整滑块',
            adjustSliderOrInput: '调整滑块或输入数字',
            realEstate: '房产投资配置金额',
        },

        section9: {
            title: '请估计您目前的净资产',
            desc: '通过了解您的净资产，我们可以推荐最适合您的产品和服务。',
            option0: '{currency} {symbol}{num1}以下',
            option1: '{currency} {symbol}{num1} - {num2}',
            option2: '{currency} {symbol}{num1} +',
        },

        section10: {
            skip: '跳过',
            title: '成为Passbook运筹会员',
            desc:
                '若您有注册邀请码，请填写该邀请码，注册成为Passbook运筹会员。成为会员后，您可随时追踪环球房产市场价格和租赁优化分析服务，优化理财。',
            invitation_code: '邀请码',
            use_code: '使用邀请码',
            enter_code: '输入邀请码',
            apply_title: '申请注册Passbook运筹会员',
            apply_desc: '为您的环球房产进行市场估值，优化租赁回报率。',
            apply: '点击申请',
            inputIsEmpty: '请输入邀请码',
            applyMsg:
                '谢谢您，我们已收到您的金房本运筹会员申请。我们将在3个工作日之内联系您。',
            successMsg: '谢谢您使用您的邀请码。欢迎加入金房本运筹会员!',
            codeExist:
                '您使用的邀请码有误。请输入新的邀请码或点击申请，我们会在3个工作日之内联系您。',
            codeExist1: '您使用的邀请码有误。试试别的邀请码',
            errorMsg: '似乎有什么东西坏掉了.. 试试刷新页面吧',
        },

        section11: {
            title: '祝贺您！您已成功注册成为金房本会员!',
            span: '',
            desc1:
                '您现已解锁金房本网站数据分析和科学算法等各类投资工具和服务。',
            desc2:
                '<span>作为我们的Passbook运筹会员</span>，您可前往金房本APP，获取您名下房产的最新估值。',
            desc4: '查看您的账号',
        },
    },

    profile: {
        name: '姓名',
        first_name: '名',
        last_name: '姓',
        email: '邮箱',
        phone: '电话号码',
        password: '密码',
        gender: '性别',
        date_of_birth: '出生日期',
        select_date: '选择日期',
        nationality: '国籍',
        city_of_residence: '居住城市',
        currency: '币种',
        preferred_currency: '默认货币',
        preferred_units: '默认测量单位',
        male: '男',
        female: '女',
        upload_avatar: '上传头像',
        upload_limit: '仅支持 GIF/JPEG/PNG 的图片格式，最大尺寸为 4MB',
        send_code: '发送验证码',
        save_changes: '保存变更',
        current_pwd: '当前密码',
        new_wd: '新密码',
        confirm_pwd: '确认新密码',
        verification_code: '验证码',
        email_placeholder: '邮箱验证码',
        phone_placeholder: '短信验证码',
        select_placeholder: '请选择',
        phone_number: '手机号码',
        country_code: '国家代码',
        upgrade_title: '会员信息 - 升级为Passbook卓越会员',
        upgrade_subtitle: '为您的环球房产进行市场估值，优化租赁回报率。',
        upgrade: '升级会员',

        email_empty: '邮箱不能为空',
        email_illegal: '请输入有效的邮箱地址',
        phone_empty: '手机号不能为空',
        phone_illegal: '请输入有效的手机号地址',

        password_empty: '请输入新密码',
        password_diff: '两次密码不一致',
        password_illegal: '您输入的密码至少要有8个字符. 您的密码不能是纯数字.',

        empty_msg: {
            first_name: '请输入您的名字',
            last_name: '请输入您的姓氏',
            birth: '请选择您的生日',
            gender: '请选择您的性别',
            cityResidence: '请输入您的居住城市',
            nationality: '请选择您的国籍',
        },
        resend_code: '{timeout}秒后发送验证码',

        email_hint:
            '<b>邮箱变更:</b> 点发送验证码到新邮箱，输入六位验证码自动提交。',
        phone_hint:
            '<b>手机号变更:</b> 点发送验证码到新手机号，输入六位验证码自动提交。',

        phone_success: '手机号修改成功',
        email_success: '邮箱修改成功',

        verification_error: '您输入的验证码错误',
        sent_code: '验证码已发送',
        try_again: '发送失败.. 请过几分钟再试试',
        fields_error: '有些选项不符合要求，请再检查一下',
        password_success: '密码修改成功',
        password_error: '密码修改失败',

        file_reader: '浏览器不支持上传头像，请升级或更换浏览器',

        upload_size_error: '上传失败， 图片大小超出了4MB限制',
        upload_success: '头像更换成功',
        upload_error: '上传失败，请检查图片大小是否超过4MB限制',

        remove_success: '删除头像成功',
        remove_error: '删除失败.. 试试刷新页面',
        basic_success: '个人信息修改成功',
        basic_error: '个人信息修改失败，请确认您的信息是正确的',

        code_error: {
            phone_already_used: '此电话号码已被占用',
            email_already_used: '此邮箱地址已被占用',
        },

        benefits: '查看会员等级方案',
        portfolio: '房产投资',
        passbook: '投资进度',
        planner: '云理财',
        chats: '客服',
        profile: '帐户',
        customer_level: {
            WEB_TRIAL: '新业会员',
            CLASSIC: '运筹会员',
            PREMIER: '卓越会员',
        },
        property: '我的房产',
        manage: '房产管理',
        settings: '设置',
    },

    portfolio: {
        title: '房产投资',
        addProp: '+ 添加房产',
        total_value: '总市值',
        total_equity: '净资产',
        total_performance: '总投资率',
        vs_purchase_price: '对比购房价格',
        monthly_performance: '月度房价变化',
        vs_last_month: '对比上个月房价',
        yield_current_val: '现价收益率',
        yield_purchase_price: '买价收益率',
        TOTAL_PORTFOLIO_VALUE: '总市值',
        GLOBAL_PORTFOLIO_BREAKDOWN: '资产配置',
        properties: '房产',
        name: '项目名',
        current_val: '当前房价',
        monthly_gain: '月增长',
        total_gain: '总增长',
        advice: '建议',
        Hold: '持有',
        Strong_Hold: '长期持有',
        Sell: '转售',
        Strong_Sell: '尽快转售',
        Not_Calculated: '目前计算中',
    },

    property: {
        ManageYourProperty: '管理您的房产',
        MortgagePaid: '贷款进度',
        PropertyValuation: '房产估值',
        PROPERTYVALUATION: '房产估值',
        selectProperty: '请选择一处您的房产',
        InternalArea: '内部面积',
        floor: '楼',
        LotSize: '外部/土地面积',
        beds: '卧室',
        bathrooms: '卫浴',
        kitchen: '厨房',
        living: '客厅',
        parking: '停车位',
        PurchaseDate: '购买日期（月/年）',
        Completion: '竣工日期',
        Ownership: '产权',
        MORTGAGE: '贷款信息',
        Mortgage: '贷款信息',
        mortgages_startDate: '{year}年{month}月',
        noMortgage: '无任何贷款，点击“编辑”为该房产填写贷款信息',
        noMortgageNull: '该房产无房屋贷款。',
        StartFrom: '贷款起始日',
        MonPayment: '每月还款',
        TotalMortgage: '总贷款',
        InterestRate: '贷款利率(%)',
        Length: '贷款年限',
        Years: '年',
        PropertyExpenses: '房产支出费用',
        Monthly: '月度',
        PropertyManagement: '物业费',
        RentalManagement: '租赁管理费',
        Tax: '房产税',
        Insurance: '保险费',
        CURRENTVALUE: '当前房价',
        PurchasePrice: '购买价格',
        CompletionDate: '竣工日期 （月/年）',
        MonthlyGain: '每月收入',
        TotalGain: '总收入',
        NoData: '暂无数据',
        NoValuation: '正在计算房产的历史评估价，请稍后查看。',
        CASHFLOW: '现金流 <span>(月度)</span>',
        NetCashFlow: '净现金流',
        CurrentRent: '当前租金',
        NetYield: '净收益率',
        MortgageExpenses: '房贷 + 支出',
        PROPERTYOUTLOOK: '展望房产投资前景',
        outlookSuggestion1:
            '长期持有：建议您在未来5-10年间持有该房产，房产增值趋势可观',
        outlookSuggestion2:
            '持有：建议您未来3-5年间持有该房产，房产增值趋势良好',
        outlookSuggestion3:
            '转售：建议您在未来1-2年间，判断市场价位后,可转售房屋',
        outlookSuggestion_no_recommend:
            '您的房产投资前景正在评估当中，请稍后查看',
        outlookSuggestion4: '尽快转售：建议您在来年判断市场价位后,可转售房屋',
        RentAnalysis: '房屋租赁分析',
        CurrentlyCalculating: '正在计算中',
        RevenueComparison: '每月租金收入对比',
        Edit: '编辑',
        MonthlyRevenue: '租金',
        GrossYield: '毛利率',
        AirbnbRentalForecast: '爱彼迎租赁平均租金估算',
        DailyRate: '单日租金',
        Occupancy: '入住率',
        StandardMonthlyRentalEstimate: '长期租赁月平均租金估算',
        StandardMonthlyRental: '长期租赁月平均租金',
        AirbnbRental1: '爱彼迎月平均租金',
        StdMonthlyHint1: '提供长期租赁的租金回报估算',
        StdMonthlyHint2: ' ,高于爱彼迎租赁平均租金收入',
        AirbnbRentalHint1: '提供爱彼迎租赁的租金回报估算',
        AirbnbRentalHint2: ' ,高于长期租赁月平均租金收入',
        BookaConsultation: '与我们沟通，了解最佳租赁方案',
        outlookHint1: '长期持有',
        outlookHint2: '持有',
        outlookHint3: '售卖',
        outlookHint4: '尽快售卖',
        TotalExpense: '总支出',
        NoRentalData: '无租赁信息。请点击“编辑”，并输入您的房屋租赁信息。',
        NotExistRentalData: '该房产无租赁收入。',
        House: '独栋别墅',
        Townhome: '联排别墅',
        Apartment: '公寓',
        Commercial: '商业用地',
        NotSetPropType: '尚未设置建筑类型',
    },

    addProperty: {
        placeholder_City: '城市',
        placeholder_address1: '东南路28号',
        placeholder_address2: '上东区',
        placeholder_propertyName: '海景公寓',
        placeholder_BuildingA: 'A幢',
        placeholder_shanghai: '上海',
        placeholder_Jingan: '静安',
        placeholder_buildingName: '汤臣一品',
        placeholder_road: '花园石桥路28弄',

        addProp: '添加房产',
        propCompleted: '该房产项目是否已竣工？',
        propCompleted_y: '已竣工',
        propCompleted_n: '施工中',
        propCompletedDate: '房产竣工时间？',
        propCompletedDate1: '竣工超过一年',
        propCompletedDate2: '竣工未满一年',
        propLocation: '房产项目地址？',
        propLocationPlaceholder: '请选择一个国家/地区',
        propType: '请选择房屋类型',
        propTypeApart: '公寓',
        propTypeHouse: '独栋别墅',
        propTypeTownhome: '联排别墅',
        propTypeCommercial: '商业用地',
        Location: '房产地址',
        city: '城市',
        postalCode: '邮编(可选)',
        address: '地址',
        address1: '地址第一行',
        address2: '地址第二行 (可选)',
        propertyName: '房产名称',
        unitNo: '单元号 (可选)',
        purchasePrice: '购买价格',
        ownership: '产权类型',
        ownership_Freehold: '永久产权',
        ownership_Leasehold: '租赁产权',
        totalLength: '租赁产权年限',
        years: '年',
        building: '建筑',
        floor: '所在楼层',
        district: '区',
        enterTip: '*请输入简体中文',
        Layout: '户型与设施',
        bedrooms: '卧室',
        bathrooms: '卫浴',
        livingRooms: '客厅',
        kitchens: '厨房',
        parkingSpaces: '停车位',
        details: '详情',
        SQM: '平方米',
        SQFT: '平方英尺',
        InternalArea: '内部面积',
        LotArea: '外部/土地面积',
        ExternalArea: '外部面积 (可选)',
        FloorOptional: '所在楼层 (可选)',
        TotalFloor: '总楼层 (可选)',
        Submit: '确认提交',
        confirm: '确认修改',
        Congratulations: '恭喜您!',
        CongratsDesc: '您的房产已成功添加至房产投资',
        CongratsDesc1:
            '若您的房屋评估价格未及时显示，我们将于48小时内为您完成评估，推送消息，通知您查看最新的房产评估价值。',
        AddNewProperty: '添加另一处房产',
        ViewPortfolio: '查看房产投资',

        selectOne: '请选择一个',
        next: '下一步',
        PortfolioTip: '房产投资 - 小贴士',
        portfolioDeatil:
            '您所填写的房产信息越具体，您的房产估值将更新的越及时准确。',
        PortfolioDetail1:
            '请放心 - 如有任何房产信息的输入匹配有误，我们将于48小时内更正且匹配成功，之后每月为您更新房产估值。',
        submitForm: '正在提交您的房产信息...',
        floorBiggerTotal: '所在楼层应小于总楼层',

        fieldsError: '请填写所有字段',
        countryError: '请选择国家',
        nameError: '请输入房产名称',
        buildingError: '请输入城市',
        addressError: '请输入房产地址',
        apartmentNumError: '请输入单元号',
        purchasePriceError: '请输入购买价格',
        yearsOfLeaseholeError: '请输入租赁产权年限',
        internalError: '请输入室内面积',
        SelectOption: '请选择一个选项',
        MonthlyRentalError: '请输入每月租金',
        interestRateError: '请输入贷款利率',
        lotAreaError: '请输入外部/土地面积',
        floorError: '请输入房子的所在楼层',
        ownershipError: '请选择产权类型',
        cityError: '请输入城市',
        districtError: '区域',
    },

    editProp: {
        backTo: '返回房产',
        editSuccess: '编辑成功!',
        Yes: '是',
        No: '没有',
        propMortgaged: '是否有贷款?',
        monthlyMortgaged: '每月还款金额',
        totalMortgaged: '贷款总额',
        intRateMortgaged: '贷款利率 (%)',
        startDate: '贷款起始日期',
        amortizationPeriod: '贷款年限',
        selectDatePlaceholder: '选择日期',
        propRented: '房租是否出租？',
        avgMontlyRent: '平均每月租金',
        expenseTracking: '房屋支出费用（月平均）',
        propManage: '物业费',
        propTax: '房产税',
        rentalManageService: '租赁管理服务',
        propInsurance: '房屋财产保险费',
    },

    searchResultPage: {
        loading: '加载中',
        header_region: '多伦多公寓',

        dropdown: '选择城市',

        projectType: {
            name: '房屋类型',
            Apartment: '公寓',
            Villa: '独栋别墅',
            Terrace: '联排别墅',
            Multiple: '多选',
            All: '全选',
        },

        avgPrice: {
            name: {
                sqft: '价格 / 平方英尺',
                sqm: '价格 / 平方米',
            },
            text: {
                sqft: '价格/平方英尺',
                sqm: '价格/平方米',
            },
            avgPrice: '平均{unit_en}为 {currency}{price_area_avg}',
            clear: '清除选项',
            apply: '确认',
        },

        startingPrice: {
            name: '起售价',
            avgPrice: '平均起售价为 ',
            clear: '清除选项',
            apply: '确认',
        },

        applyFilters: '确认筛选',

        applyFilters_sm: '确认',

        top10: '优选房源',

        loadMore: '加载更多',

        resultCount: '共查询到 {count} 条结果',

        noResult: '未搜索到结果，看看下面{region}的其他项目吧',

        resultHint: '试试调整一下筛选条件，可能会有更多结果。',

        removeFilters: '移除所有筛选条件',

        Filters: '筛选',

        overall: '总分',

        card: {
            sqft: '平方英尺',
            sqm: '平方米',
            startingPrice: '起售价',
        },

        placeholder: {
            header_input: '选择城市',
        },

        heatmapMode: '城市活跃地图',

        clearAll: '清除全部',

        scorebox: {
            rank: '城市排名',
            score: '城市得分',
            median_price: '平均价格',
            gross_yield: '平均毛收益率',
            score_tooltip: '每个城市住宅房地产投资属性的累计得分',
            rank_tooltip:
                '城市排名由城市得分决定，每月由 PropertyPassbook 发布',
        },

        highest: '最高',
        momentumScoere: '活跃度得分',
        lowest: '最低',

        viewMap_btn: '查看地图位置',
        viewProject_btn: '查看项目详情',
        overall_score: '总体得分',

        // viewProject: "查看详情"
    },

    reservationSelectUnit: {
        title: '请选择户型',
        alert: '请先选择户型，方可预留房源。',
    },

    reservationPayment: {
        method: '请选择付款方式',
        promise:
            '每笔交易都经过加密处理并保障交易安全。我们承诺绝不会在未经您允许的情况下储存您的信用卡信息。',
        creditCard: '信用卡',
        creditCard1: '信用卡卡号',
        creditCard2: '持卡人姓名',
        creditCard3: '有效期至',
        creditCard4: 'CVV',
        creditCard_msg1: '位于信用卡背面的3位数字',
        creditCard_msg2: '您的信用卡信息填写有误，请查验。',
        available: '（仅适用于人民币支付）',
        scanQR: '请扫码支付',
        wechat: '微信',
        scanWechat: '请打开微信并扫码支付订金',
        alipay: '支付宝',
        scanAlipay: '请打开支付宝并扫码支付订金',
        promise1: '我们承诺并保障您的信息安全',
        promise2: '我们承诺绝不向第三方售卖您的个人信息',
        promise_title1: '安全退出',
        promise_title2: '所有的信息都已通过',
        promise_title2_hint: 'SSL 安全',
        promise_title2_1: '协议进行传输和加密，保证您的信息安全。',
    },

    reservationConfirm: {
        thanks: '谢谢',
        thanks_1: '您',
        confirmed: '您的预约',
        confirmed_1: '已确认',
        confirmed_2: '！',
        contact:
            '我们已收到您的请求。在接下来的24小时内，我们将通过邮件告知您下一步的操作。',
        backHome: '返回主页',
    },

    reservation: {
        // "q": "？",
        step_1: '请选择户型',
        step_2: '订金支付',
        step_3: '房源预留已确认',
        back: '返还',
        backToUnit: '返回选择户型',
        unitReservation: '预留房源',
        waiver: '是否需要？',
        waiver_1: '免除订金？',
        waiver_msg: '请输入订金免除码。',
        apply: '确定',
        subTotal: '小计',
        reservationWaiver: '订金免除',
        remove: '扣除',
        total: '总计',
        used: '我的订金将被如何处理？',
        rApplied: '您的订金将用于您的',
        rApplied_1: '首次房款支付',
        noReservation: '无需支付订金',
        free: '您的订金费用',
        free_1: '已免除',
        symbol: '！',
        purchase:
            '房屋购买于签署购房合同时生效。成功预留房源不能代表您已成功购买该房源',
        next: '下一步',
        reserve: '现在预留房源',
        privacy1: '点击“现在预留房源”，表示我同意金房本的',
        privacy2: '服务条款',
        privacy2_1: '和',
        privacy2_2: '隐私权政策',
        enterWaiver: '请输入订金免除码',
        selectHint: '请选择您的户型',
    },

    reservation_h5: {
        wechat: 'Add Wechat',
        scanCode: 'Scan the QR code ',
        scanWechat: 'with Wechat mobile app to make a reservation.',
        alipay: 'Add Alipay',
        scanAlipay: 'with Alipay mobile app to make a reservation. Or',
        redirect: 'input Alipay account info.',
    },

    citySelection: {
        asia: '亚太地区',

        asia1: '奥克兰',
        asia2: '马尼拉',
        asia3: '曼谷',
        asia4: '墨尔本',
        asia5: '北京',
        asia6: '芭提亚',
        asia7: '布里斯班',
        asia8: '珀斯',
        asia9: '清迈',
        asia10: '普吉岛',
        asia11: '迪拜',
        asia12: '罗勇府',
        asia13: '胡志明市',
        asia14: '上海',
        asia15: '香港',
        asia16: '新加坡',
        asia17: '华欣-七岩',
        asia18: '悉尼',
        asia19: '苏梅岛',
        asia20: '甲米府',

        europe: '欧洲地区',

        europe1: '巴塞罗那',
        europe2: '柏林',
        europe3: '伯明翰',
        europe4: '布鲁塞尔',
        europe5: '法兰克福',
        europe6: '里斯本',
        europe7: '利物浦',
        europe8: '伦敦',
        europe9: '马德里',
        europe10: '曼切斯特',
        europe11: '巴黎',

        northAmerica: '北美地区',

        northAmerica1: '亚特兰大',
        northAmerica2: '蒙特利尔',
        northAmerica3: '奥斯汀',
        northAmerica4: '纽约市',
        northAmerica5: '波士顿',
        northAmerica6: '奥兰多',
        northAmerica7: '卡尔加里',
        northAmerica8: '渥太华',
        northAmerica9: '达拉斯',
        northAmerica10: '旧金山',
        northAmerica11: '哈密尔顿',
        northAmerica12: '圣何塞',
        northAmerica13: '休斯顿',
        northAmerica14: '西雅图',
        northAmerica15: '基隆拿',
        northAmerica16: '多伦多',
        northAmerica17: '基奇纳-滑铁卢',
        northAmerica18: '温哥华',
        northAmerica19: '洛杉矶',
        northAmerica20: '维多利亚',
        northAmerica21: '迈阿密',
        northAmerica22: '华盛顿特区',
    },

    cityRanking: {
        title: '全球最优房地产投资城市排行榜 - ',
        subTitle:
            '金房本的房地产投资城市排行榜涵盖了全球主要的经济发达地区和新兴起市场，通过对各个城市进行的多维度分析，以确定各城市的住宅房地产行业成长潜力和社会经济发展趋势。此排行榜每月定期更新，敬请关注。',
        cityRank: '城市排名',
        city: '城市',
        cityScore: '城市得分',
        tooltip: '每个城市住宅房地产投资属性的累计得分',
        avgGrowth: '近5年平均人口增长率',
        medianPrice: '平均价格',
        grossYield: '平均毛收益率',
        select: '请选择',
        selectOne: '请选择',
        noResult: '暂无数据',
        all: '全部 ',
        allCountry: '全部国家',
    },

    cityRanking_selection: {
        cancel: '取消',
        timeframe: '请选择时间段',
        done: '完成',
        comparison: '选择城市进行比较',
        selectRegion: '选择地区',
        continets: '洲',
        countries: '国家',
    },
};



//////////////////
// WEBPACK FOOTER
// ./lang/zh-hans.js
// module id = 8+sJ
// module chunks = 0